import type { NotificationProps } from '../../../components/Notification/types/propsTypes';
import { ComponentType } from '../../registries/types/propTypes';
const transformNotification = (data: NotificationProps) => ({
  componentType: ComponentType.notification,
  message: data?.message,
  _version: data?._version as number,
  callBack: data?.callBack,
});
export default transformNotification;
